/**
 * A global namespace for `readystatechange` event.
 */
const readystatechangeEvent = 'readystatechange';
export default readystatechangeEvent;
